module.exports = __webpack_public_path__ + "img/padPright.8def505b.png";